import { render, staticRenderFns } from "./inquiry-follow-up.vue?vue&type=template&id=7a8c9eb6"
import script from "./inquiry-follow-up.vue?vue&type=script&lang=js"
export * from "./inquiry-follow-up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports